import { Stack, Typography } from "@mui/material";
import { EditableDataGrid } from "../../../builderPackage/components/editableDataGrid/editableDataGrid";
import { RowModeIds } from "../../../builderPackage/components/editableDataGrid/editableDataGrid.entity";
import { MuiStack } from "../../../components";
export var PartDetails = function (props) {
    var onChange = props.onChange, value = props.value, error = props.error, _a = props.name, name = _a === void 0 ? 'partDetails' : _a;
    var currValue = value[name];
    var partsColumns = [{
            field: 'ChildName',
            headerName: 'Part name & code',
            width: 200,
            headerAlign: 'left',
            disableColumnMenu: true,
            renderCell: function (params) {
                if ((params === null || params === void 0 ? void 0 : params.id) === RowModeIds.Aggregation) {
                    return 'Total';
                }
                else {
                    var _params$row$ItemName, _params$row, _params$row2, _params$row3;
                    return /*#__PURE__*/ React.createElement(MuiStack, {
                        direction: 'column'
                    }, /*#__PURE__*/ React.createElement(Typography, {
                        sx: {
                            fontSize: 'sm',
                            fontWeight: 'ormal',
                            color: 'text.primary'
                        }
                    }, (_params$row$ItemName = params === null || params === void 0 || (_params$row = params.row) === null || _params$row === void 0 ? void 0 : _params$row.ItemName) !== null && _params$row$ItemName !== void 0 ? _params$row$ItemName : ""), /*#__PURE__*/ React.createElement(Typography, {
                        sx: {
                            fontSize: 'sm',
                            fontWeight: 'ormal',
                            color: 'text.tertiary'
                        }
                    }, params !== null && params !== void 0 && (_params$row2 = params.row) !== null && _params$row2 !== void 0 && _params$row2.ItemCode ? "#".concat(params === null || params === void 0 || (_params$row3 = params.row) === null || _params$row3 === void 0 ? void 0 : _params$row3.ItemCode) : ""));
                }
            }
        }, {
            field: 'UOM',
            headerName: 'UOM',
            width: 100,
            headerAlign: 'left',
            disableColumnMenu: true
        }, {
            field: 'ContractTypeName',
            headerName: 'Service type',
            width: 150,
            headerAlign: 'left',
            disableColumnMenu: true
        }, {
            field: 'MechanicName',
            headerName: 'Technician',
            width: 150,
            headerAlign: 'center',
            disableColumnMenu: true
        }, {
            field: 'Qty',
            headerName: 'Quantity',
            width: 150,
            headerAlign: 'center',
            disableColumnMenu: true,
            type: 'number'
        }, {
            type: 'number',
            field: 'Rate',
            headerName: 'Rate (₹)',
            align: 'center',
            width: 100,
            headerAlign: 'center',
            disableColumnMenu: true,
            valueFormatter: function (params) {
                var value = Number(params);
                if (value) {
                    return value === null || value === void 0 ? void 0 : value.toFixed(2);
                }
                else {
                    return '';
                }
            }
        }, {
            field: 'ComplaintName',
            headerName: 'Complaint name',
            width: 150,
            headerAlign: 'left',
            disableColumnMenu: true,
            editable: false
        }, {
            field: 'CustomerComplaintName',
            headerName: 'Customer complaint name',
            width: 130,
            headerAlign: 'left',
            disableColumnMenu: true,
            editable: false
        }, {
            field: 'Amount',
            headerName: 'Amount (₹)',
            width: 130,
            headerAlign: 'left',
            disableColumnMenu: true,
            type: 'number',
            valueFormatter: function (params) {
                var value = Number(params);
                if (value) {
                    return value === null || value === void 0 ? void 0 : value.toFixed(2);
                }
                else {
                    return '';
                }
            }
        }];
    return /*#__PURE__*/ React.createElement(Stack, {
        sx: {
            margin: '0px 24px 20px 24px'
        }
    }, /*#__PURE__*/ React.createElement(EditableDataGrid, {
        dataGridHeader: "Part Details",
        isCollapsible: true,
        columns: partsColumns,
        disableAddRow: true,
        disableDeleteRow: true
        // disableToolbarActions
        ,
        dataGridProps: {
            checkboxSelection: false,
            disableRowSelectionOnClick: true,
            hideFooter: true,
            initialState: {
                pinnedColumns: {
                    right: ['Amount']
                },
                aggregation: {
                    model: {
                        QtyIssued: 'sum',
                        Amount: 'sum'
                    }
                }
            }
        },
        rows: currValue || [],
        onChange: onChange,
        error: error === null || error === void 0 ? void 0 : error[name]
    }));
};
